define('bindings/knockout.loadingindicator',["jquery", "knockout"], function ($, ko) {
    ko.bindingHandlers.btnLoadingIndicator = {
        init: function(element, valueAccessor, allBindingsAccessor) {
            $('<svg viewBox="0 0 512 512" class="btn-loading"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>').appendTo(element);

            var value = ko.utils.unwrapObservable(valueAccessor());
            if(value) {
                $(element).addClass("is-loading");
                $(element).attr("disabled", "disabled");
            } else {
                $(element).removeClass("is-loading");
                $(element).removeAttr("disabled");
            }
        },

        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            if(value) {
                $(element).addClass("is-loading");
                $(element).attr("disabled", "disabled");
            } else {
                $(element).removeClass("is-loading");
                $(element).removeAttr("disabled");
            }
        }        
    };
    
    return ko.bindingHandlers.btnLoadingIndicator;
});
